import {
  getStorage,
  ref,
  uploadString,
  getDownloadURL,
} from "firebase/storage";

const storage = getStorage();

export async function uploadToStorage(path, file) {
  return new Promise(function (resolve, reject) {
    if (!file) return;

    const storageRef = ref(storage, path);
    uploadString(storageRef, file, "data_url", { public: true }).then(
      (snapshot) => {
        getDownloadURL(snapshot.ref).then((downloadURL) => {
          // console.log("File available at", downloadURL);
          resolve(downloadURL);
        });
      }
    );
  });
}
